/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event){

    // GSAP matchMedia
    var mm = gsap.matchMedia();

    // GSAP services animations
    var servicesHeading = document.querySelector('.services-list-header-content h2');
    var servicesHeadingAnimated = new SplitType(servicesHeading);
    var servicesContainer = document.querySelector('.wp-block-create-block-swiftpay-services-list');
    var servicesItems = document.querySelectorAll('.services-list-item');

    function initServicesScrollAnimation(){
        gsap.fromTo(servicesHeadingAnimated.chars, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: "power3.inOut",
            stagger: 0.01,
            scrollTrigger: {
                trigger: servicesContainer,
                start: "top +=90%",
                end: "bottom bottom"
            }
        });

        var servicesItemsScrollAnimationTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: servicesContainer,
                start: "top +=20%",
                end: "bottom bottom"
            },
        });

        servicesItemsScrollAnimationTimeline.fromTo(
            servicesItems,
            {
                xPercent: -25, // Starting position
            },
            {
                xPercent: 0, // End position
                duration: 1,
                ease: "power3.inOut",
                stagger: 0.2
            }
        );
    }

    mm.add("(min-width: 1024px)", function() {
        initServicesScrollAnimation();
    });
});
